const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_onboarding/onboarding/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
const $$splitLoaderImporter = () => import('/app/apps/web/src/routes/_onboarding/onboarding/index.tsx?tsr-split=loader');
import { lazyFn } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import { createTranslator } from "use-intl";
import { buildPrivatePageMetaTags } from "@/lib/seo-meta";
import { getRootLoaderData } from "@/types/intl";
export const Route = createFileRoute("/_onboarding/onboarding/")({
  // Session was already resolved in the parent `_onboarding.tsx` beforeLoad
  // (which also handles redirects for no-session / already-onboarded). The
  // user snapshot propagates down via route context so we can hand it to the
  // wizard as its initial form state.
  loaderDeps: () => ({}),
  loader: lazyFn($$splitLoaderImporter, 'loader'),
  head: ({
    match
  }) => {
    const {
      locale,
      messages
    } = getRootLoaderData(match);
    const tMeta = createTranslator({
      locale,
      messages,
      namespace: "globals.metadata"
    });
    return {
      meta: buildPrivatePageMetaTags(tMeta("onboarding"))
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});